import PricingManager from "./PricingManager";
import { LeftSide } from "./leftSide";
import CouponTable from "./CouponTable";

function AdminSettings() {
  return (
    <div className="p-4 h-full bg-gray-100 overflow-auto pb-28 md:pb-0">
      <div className="flex flex-col xl:flex-row lg:flex-row gap-4">
        <div className="w-full lg:w-2/4 xl:w-2/4">
          <LeftSide />
        </div>
        <div className="w-full lg:w-2/4 xl:w-2/4">
          <div className="flex h-auto">
            <PricingManager />
          </div>
          <div className="flex h-auto">
            <CouponTable />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminSettings;
